var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSuccess = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "success",
    d: "M10.2,20a10,10,0,1,1,10-10A10.011,10.011,0,0,1,10.2,20Zm0-18.1A8.1,8.1,0,1,0,18.3,10,8.113,8.113,0,0,0,10.2,1.9Zm1.145,10.788,3.746-3.769a.948.948,0,1,0-1.345-1.336L10,11.348a1.04,1.04,0,0,1-1.482,0L6.7,9.519a.948.948,0,0,0-1.346,1.335l1.814,1.83a2.936,2.936,0,0,0,4.174,0Z",
    transform: "translate(-0.196)",
    fill: "#11616a"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/success.a6cddbea.svg";
export { ForwardRef as ReactComponent };